import request from '@/utils/request';

const requestInstance = request();

/**
 * 获取当前用户消息推送列表接口
 * @returns {*}
 */
export function listMessageNotificationOrganConfigByPage(parameter) {
  return requestInstance.post('/api/config/devListMessageNotificationOrganConfigByPage', parameter);
}

/**
 * 获取当前企业未设置的推送类型
 */
export function devGetMessageNotifationOrganNoSet(data) {
  return requestInstance.post('/api/config/devGetMessageNotifationOrganNoSet', data);
}
/**
 * 获取当前企业未设置的推送类型
 */
export function devGetMessageNotifationOrganSet(data) {
  return requestInstance.post('/api/config/devGetMessageNotifationOrganSet', data);
}
/**
 * 在后台发送post请求
 */
export function devPostMessage(data) {
  return requestInstance.post('/api/config/devPostMessage', data);
}

/**
 * 新增推送信息配置
 */
export function devAddMessagePush(data) {
  return requestInstance.post('/api/config/devBatchAddMessageNotificationOrganConfig', data);
}


/**
 * 修改推送信息配置
 */
export function devEditMessagePush(data) {
  return requestInstance.post('/api/config/devUpdateMessageNotificationOrganConfig', data);
}

/**
 * 删除推送信息配置
 */
export function devDeleteMessagePush(data) {
  return requestInstance.post('/api/config/devBatchDeleteMessageNotificationOrganConfig', data);
}

/**
 * 获取当前企业白名单列表
 */
export function getWhiteListByOrganId() {
  return requestInstance.post('/api/MessageNotificationWhiteList/getWhiteListByOrganId');
}

/**
 * 增加当前企业白名单列表
 */
export function addWhiteList(data) {
  return requestInstance.post('/api/MessageNotificationWhiteList/addWhiteList', data);
}

/**
 * 更新当前企业白名单列表
 */
export function updateWhiteList(data) {
  return requestInstance.post('/api/MessageNotificationWhiteList/updateWhiteList', data);
}

/**
 * 根据key获取字典信息
 */
export function devGetDictDictionaryList(data) {
  return requestInstance.post('/api/dataDictionary/getDataDictionaryList', data);
}
